// #150: the client-side counterpart to #149's biopolymerDrawing schema. Peptide-only v1, per
// #133's decision record -- residues reference existing Molecules directly (no Isomer, no
// depiction), the same reference-based idiom Reaction/Illustration already use.

export interface BiopolymerResiduePick {
  readonly localId: string;
  readonly moleculeId: string;
  readonly moleculeRevision: number;
}

export interface BiopolymerResidue {
  readonly position: number;
  readonly monomer: {
    readonly moleculeId: string;
    readonly moleculeRevision: number;
  };
}

export interface BiopolymerDrawingDocument {
  readonly schemaVersion: 'chem-drawing.v11';
  readonly kind: 'biopolymer';
  readonly residues: readonly BiopolymerResidue[];
}

export function buildBiopolymerResidues(picks: readonly BiopolymerResiduePick[]): readonly BiopolymerResidue[] {
  return picks.map((pick, index) => ({
    position: index + 1,
    monomer: { moleculeId: pick.moleculeId, moleculeRevision: pick.moleculeRevision }
  }));
}
